module.exports = __webpack_public_path__ + "top_page/icon-search-6b373e6f318b86f0b7002b3976acf2ff.svg";